import React, { Component } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import AnswerNode from "./AnswerNode";
import CardHeader from "@material-ui/core/CardHeader";
import KpsEditor from "../editor/KpsEditor";

class QuestionNode extends Component {
  render() {
    return (
      <div>
        <CardHeader title={this.props.node.label} id="node-label" />
        <DialogContent>
          <KpsEditor initialContent={this.props.node.notes} readOnly />
        </DialogContent>
        {this.props.node.children.map((child, idx) => (
          <AnswerNode
            changeQuestion={this.props.changeQuestion}
            node={child}
            key={idx}
          />
        ))}
      </div>
    );
  }
}
export default QuestionNode;
